import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { useRef, useContext, useEffect } from 'react';
import { useTransition } from 'react-spring/web.cjs';
import { FixedSizeList } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import AutoSizer from 'react-virtualized-auto-sizer';
import { animationConfig } from '../animation/animationConfig.js';
import AnimationContext from '../AnimationState.js';
import VirtualizedItem from './VirtualizedItem.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'constate';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function VirtualizedList(_ref) {
  var items = _ref.items,
      itemRenderer = _ref.itemRenderer,
      searching = _ref.searching,
      _ref$target = _ref.target,
      target = _ref$target === void 0 ? false : _ref$target,
      innerRef = _ref.innerRef,
      children = _ref.children,
      _ref$hasNextPage = _ref.hasNextPage,
      hasNextPage = _ref$hasNextPage === void 0 ? true : _ref$hasNextPage,
      _ref$getMoreItems = _ref.getMoreItems,
      getMoreItems = _ref$getMoreItems === void 0 ? function () {} : _ref$getMoreItems;
  var hasMounted = useRef(false);

  var _useContext = useContext(AnimationContext.Context),
      _useContext$state = _useContext.state,
      isMoving = _useContext$state.isMoving,
      isMovingBack = _useContext$state.isMovingBack,
      reset = _useContext.reset;

  useEffect(function () {
    hasMounted.current = true;
  }, []);
  var transitions = useTransition(items, function (item) {
    return item.id;
  }, _objectSpread(_objectSpread({}, animationConfig.moveItem(target)), {}, {
    onDestroyed: function onDestroyed() {
      return reset();
    }
  }));
  var itemCount = hasNextPage ? items.length + 1 : items.length;

  var isItemLoaded = function isItemLoaded(index) {
    return !hasNextPage || index < items.length;
  };

  return /*#__PURE__*/React.createElement(AutoSizer, null, function (_ref2) {
    var height = _ref2.height,
        width = _ref2.width;
    return /*#__PURE__*/React.createElement(InfiniteLoader, {
      isItemLoaded: isItemLoaded,
      itemCount: itemCount,
      loadMoreItems: getMoreItems
    }, function (_ref3) {
      var onItemsRendered = _ref3.onItemsRendered,
          ref = _ref3.ref;
      return /*#__PURE__*/React.createElement(FixedSizeList, {
        height: searching ? 300 : height,
        width: width,
        innerRef: innerRef,
        itemCount: transitions.length,
        itemData: {
          items: transitions,
          itemRenderer: itemRenderer,
          isItemMoving: hasMounted.current && (isMoving || isMovingBack)
        },
        itemSize: 35,
        onItemsRendered: onItemsRendered,
        ref: ref
      }, children || VirtualizedItem);
    });
  });
}

export default VirtualizedList;
//# sourceMappingURL=VirtualizedList.js.map
